<div class="flex flex-col mt-10">
  <div class="overflow-x-auto mx-auto w-full md:max-w-screen-xl">
    <div class="inline-block w-full py-2 align-middle">
      <!-- Cabeçalho -->
      <div class="flex justify-between items-center px-5 mb-4">
        <span class="text-black font-black uppercase">Editar Setup</span>
        <button
          type="button"
          class="btn-close"
          aria-label="Fechar formulário"
          routerLink="/dash/setups"
          appCloseOnEscape
        >
          <lucide-icon name="x" [size]="20"></lucide-icon>
        </button>
      </div>

      <form class="flex flex-col gap-6" [formGroup]="formSetup">
        <!-- Seção 1: Dados Básicos -->
        <div class="bg-white rounded-2xl shadow-md px-6 py-5 mx-5">
          <h3 class="font-bold text-chathams-blue mb-4">Informações Iniciais</h3>
          <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
            <div class="form-group">
              <label for="input-name" class="text-sm font-medium text-chathams-blue mb-1">Nome do setup</label>
              <input type="text" class="form-input" placeholder="Nome" formControlName="name" />
            </div>

            <div class="form-group" *isAllowed="[ERoleAdminString.Admin]">
              <label for="input-name" class="text-sm font-medium text-chathams-blue mb-1">Empresa</label>
              <ng-select
                notFoundText="Nenhum item encontrado"
                [searchable]="false"
                placeholder="Empresa"
                formControlName="companyId"
              >
                <ng-option *ngFor="let company of companies" [value]="company.id">{{ company.name }}</ng-option>
              </ng-select>
            </div>
          </div>
        </div>

        <!-- Seção 2: Configurações -->
        <div
          class="bg-white rounded-2xl shadow-md px-6 py-5 mx-5"
          *isAllowed="[ERoleAdminString.Admin, 'setup.edit']"
          formGroupName="setupConfig"
        >
          <h3 class="font-bold text-chathams-blue mb-4">Configurações</h3>
          <div class="flex flex-wrap gap-4">
            <div class="form-group">
              <label for="input-name" class="text-sm font-medium text-chathams-blue mb-1"> Modulo inicial </label>
              <ng-select
                notFoundText="Nenhum item encontrado"
                [searchable]="false"
                placeholder="Modulo para retornar ao terminar o fluxo."
                formControlName="home"
              >
                <ng-option *ngFor="let optionHome of homeModuleOptions" [value]="optionHome.id">
                  {{ optionHome.name }}
                </ng-option>
              </ng-select>
            </div>

            <div class="form-group">
              <label for="input-idle-timeout" class="text-sm font-medium text-chathams-blue mb-1"
                >Tempo até "Ainda está aí?" (s)</label
              >
              <input
                id="input-idle-timeout"
                formControlName="idleTimeoutS"
                class="form-input"
                type="number"
                min="1"
                placeholder="Padrão: 60"
              />
            </div>

            <div class="form-group">
              <label for="input-warning-countdown" class="text-sm font-medium text-chathams-blue mb-1"
                >Contagem do aviso (s)</label
              >
              <input
                id="input-warning-countdown"
                formControlName="warningCountdownS"
                class="form-input"
                type="number"
                min="1"
                placeholder="Padrão: 15"
              />
            </div>

            <div class="form-group">
              <label for="input-name" class="text-sm font-medium text-chathams-blue mb-1"
                >Tema Customizado no App</label
              >
              <ng-select
                notFoundText="Nenhum item encontrado"
                [searchable]="false"
                placeholder="Usar Tema Customizado no App"
                formControlName="setupTheme"
              >
                <ng-option *ngFor="let theme of optionsTheme" [value]="theme.value">{{ theme.label }}</ng-option>
              </ng-select>
            </div>

            <div class="flex flex-wrap p-8 w-full col-span-3 gap-4">
              <div class="form-group">
                <label class="flex items-center gap-2 cursor-pointer">
                  <span class="text-sm font-medium text-chathams-blue whitespace-nowrap"
                    >Ativar verificação de pagamento</span
                  >
                  <input type="checkbox" formControlName="checkValidPayment" class="toggle-checkbox hidden" />
                  <span class="toggle-switch"></span>
                </label>
              </div>

              <div class="form-group">
                <label class="flex items-center gap-2 cursor-pointer">
                  <span class="text-sm font-medium text-chathams-blue whitespace-nowrap"
                    >Utiliza fluxo de telemedicina?</span
                  >
                  <input type="checkbox" formControlName="hasTelemedicine" class="toggle-checkbox hidden" />
                  <span class="toggle-switch"></span>
                </label>
              </div>

              <div class="form-group">
                <label class="flex items-center gap-2 cursor-pointer">
                  <span class="text-sm font-medium text-chathams-blue whitespace-nowrap">Acessibilidade por voz</span>
                  <input type="checkbox" formControlName="accessibilityVoice" class="toggle-checkbox hidden" />
                  <span class="toggle-switch"></span>
                </label>
              </div>
            </div>

            <div class="col-span-3 px-8 pb-8">
              <app-setup-identification
                [anonymousControl]="anonymousControl"
                [registrationGroup]="registrationGroup"
                [ageGenderModuleNames]="ageGenderModuleNames"
              ></app-setup-identification>
            </div>
          </div>
        </div>
        <!-- Seção 3: Módulos -->
        <div class="grid grid-cols-3 gap-5 mx-5">
          <div class="col-span-2 bg-white rounded-2xl shadow-md px-6 py-5">
            <h3 class="font-bold text-chathams-blue mb-4">Módulos do Fluxo</h3>
            <div
              class="max-h-[600px] overflow-y-auto"
              cdkDropList
              [cdkDropListDisabled]="modules.length < 2"
              (cdkDropListDropped)="drop($event)"
            >
              <div *ngFor="let module of modules; let i = index" class="mb-4" cdkDrag>
                <div
                  class="bg-white hover:bg-gray-50 p-4 flex items-center border justify-between border-iceberg rounded-md"
                >
                  <div class="flex items-center">
                    <div class="font-medium text-md text-chathams-blue whitespace-nowrap">
                      {{ i + 1 }}. {{ module.name }}
                    </div>
                    <div class="ml-2 flex items-center gap-1 text-chathams-blue">
                      <mat-icon matTooltip="Requer autenticação" *ngIf="module.requiresAuth">login</mat-icon>
                      <mat-icon matTooltip="Requer triagem" *ngIf="module.requiresTriage">checklist</mat-icon>
                      <mat-icon
                        *ngIf="hasUnmetDependencies(module)"
                        [matTooltip]="'Requer: ' + getMissingDependencyNames(module).join(', ')"
                        color="warn"
                        class="animate-pulse"
                      >
                        warning
                      </mat-icon>
                    </div>
                  </div>

                  <div class="flex items-center gap-2">
                    <button
                      *ngIf="module.hasConfigModule || hasConfig(module.configModule)"
                      [routerLink]="'module/' + module.id"
                      [queryParams]="{ setupId: setupId }"
                      mat-icon-button
                      class="text-cerise-red"
                      matTooltip="Configurações do Módulo"
                    >
                      <mat-icon>settings</mat-icon>
                    </button>

                    <mat-menu #connectionMenu="matMenu">
                      <button
                        *ngFor="let option of getPossibleConnections(module, i)"
                        (click)="toggleConnection(module, option.id)"
                        mat-menu-item
                      >
                        <mat-icon>{{
                          isConnected(module, option.id) ? 'check_box' : 'check_box_outline_blank'
                        }}</mat-icon>
                        <span>{{ option.name }}</span>
                      </button>
                    </mat-menu>
                    <button
                      *ngIf="getPossibleConnections(module, i).length > 0"
                      mat-icon-button
                      [matMenuTriggerFor]="connectionMenu"
                      matTooltip="Definir Rotas Adicionais"
                    >
                      <mat-icon>fork_right</mat-icon>
                    </button>

                    <button (click)="removeModule(module)" mat-icon-button color="warn" matTooltip="Remover Módulo">
                      <mat-icon>remove_circle_outline</mat-icon>
                    </button>
                  </div>
                </div>

                <div
                  *ngIf="module.displayConnections && module.displayConnections.length > 1"
                  class="mt-2 px-4 py-2 border-t border-gray-100"
                >
                  <h4 class="text-xs font-bold text-gray-500 uppercase mb-2">Rotas</h4>
                  <div class="flex flex-wrap gap-2">
                    <span
                      *ngFor="let connection of module.displayConnections"
                      class="bg-gray-200 text-gray-800 text-xs font-medium px-2.5 py-1 rounded-full"
                    >
                      {{ connection.name }}
                    </span>
                  </div>
                </div>

                <div
                  *ngIf="hasUnmetDependencies(module)"
                  class="mt-1 px-3 py-1 bg-yellow-50 border border-yellow-300 rounded text-xs text-yellow-700 flex items-center gap-1"
                >
                  <mat-icon class="text-sm">warning</mat-icon>
                  Dependências ausentes: {{ getMissingDependencyNames(module).join(', ') }}
                </div>
              </div>

              <div *ngIf="modules.length === 0" class="text-center text-gray-500 p-10 bg-gray-50 rounded-lg">
                <p>Nenhum módulo no fluxo.</p>
                <p class="text-sm">Adicione módulos da lista à direita para começar.</p>
              </div>
            </div>
          </div>

          <div class="col-span-1 bg-white rounded-2xl shadow-md px-6 py-5">
            <h3 class="font-bold text-chathams-blue mb-4">Módulos Disponíveis</h3>
            <div class="flex flex-col gap-2 max-h-[600px] overflow-y-auto">
              <div
                *ngFor="let module of availableModules"
                class="bg-white hover:bg-iceberg p-4 flex items-center border justify-between border-iceberg rounded-md"
              >
                <span class="font-medium text-md text-chathams-blue">{{ module.name }}</span>
                <button
                  (click)="addModule(module)"
                  mat-mini-fab
                  class="bg-chathams-blue"
                  matTooltip="Adicionar Módulo ao Fluxo"
                >
                  <mat-icon>add</mat-icon>
                </button>
              </div>

              <div *ngIf="availableModules.length === 0" class="text-center text-gray-500 p-10 bg-gray-50 rounded-lg">
                <p>Todos os módulos já foram adicionados.</p>
              </div>
            </div>
          </div>
        </div>

        <div class="form-group flex flex-col items-center justify-center gap-2">
          <p *ngIf="hasUnsavedModules" class="text-sm text-chathams-blue text-center" role="status">
            Os módulos novos e as configurações deles ficam no rascunho e só serão gravados quando você salvar o setup.
          </p>
          <button
            *isAllowed="[ERoleAdminString.Admin, 'setup.edit']"
            type="button"
            (click)="editSetup()"
            [disabled]="saving"
            [attr.aria-busy]="saving"
            class="w-80 h-9 btn btn--secondary"
          >
            {{ saving ? 'Salvando...' : '+ Salvar setup' }}
          </button>
        </div>
      </form>
    </div>
  </div>
  <router-outlet></router-outlet>
</div>
